import { ACTIONS, SAGA_ACTIONS } from "../../../_config";

export interface JobPostingFormData {
  // Step 1 - Basic Information
  title: string;
  jobDescription: string;
  jobPostType: string;
  workplace: string;
  country: string;
  jobLocation: string;
  salaryRange: string;
  vacancies: number;

  // Step 2 - Job Description
  roleDescription: string;
  skills: string[];
  rejectionSettings: string;
  selectedLanguages: string[];

  // Additional fields
  selectedLocationTags?: string[];
  selectedSkills?: string[];
  customSkills?: string[];
  selectedCountryId?: number | null;
  selectedCurrency?: any;
}

export interface JobPostingState {
  formData: JobPostingFormData;
  currentStep: number;
}

const initialState: JobPostingState = {
  formData: {
    title: "",
    jobDescription: "",
    jobPostType: "",
    workplace: "",
    country: "",
    jobLocation: "",
    salaryRange: "",
    vacancies: 1,
    roleDescription: "",
    skills: [],
    rejectionSettings: "",
    selectedLanguages: ["English"],
    selectedLocationTags: [],
    selectedSkills: ["JavaScript", "React", "Node.js"],
    customSkills: [],
    selectedCountryId: null,
    selectedCurrency: null,
  },
  currentStep: 1,
};

const jobPostingReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SAGA_ACTIONS.JOB_POSTING.UPDATE_FORM_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          ...action.payload,
        },
      };

    case SAGA_ACTIONS.JOB_POSTING.UPDATE_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };

    case SAGA_ACTIONS.JOB_POSTING.RESET_FORM:
      return {
        ...initialState,
      };

    case SAGA_ACTIONS.JOB_POSTING.SET_SELECTED_SKILLS:
      return {
        ...state,
        formData: {
          ...state.formData,
          selectedSkills: action.payload,
        },
      };

    case SAGA_ACTIONS.JOB_POSTING.SET_SELECTED_LANGUAGES:
      return {
        ...state,
        formData: {
          ...state.formData,
          selectedLanguages: action.payload,
        },
      };

    case SAGA_ACTIONS.JOB_POSTING.SET_SELECTED_COUNTRY:
      return {
        ...state,
        formData: {
          ...state.formData,
          selectedCountryId: action.payload,
        },
      };

    case SAGA_ACTIONS.JOB_POSTING.SET_SELECTED_CURRENCY:
      return {
        ...state,
        formData: {
          ...state.formData,
          selectedCurrency: action.payload,
        },
      };

    case ACTIONS.USER.LOGIN:
    case ACTIONS.USER.LOGOUT:
      return { ...initialState };

    default:
      return state;
  }
};

export default jobPostingReducer;
